"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withWrapOnSubmit = exports.withToggleButton = exports.withToggle = exports.withToggleTo = exports.withToggleOnSubmit = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@bodiless/core");

var mobx_react_lite_1 = require("mobx-react-lite");

var useAccessors = function useAccessors() {
  var node = core_1.useNode().node;
  return {
    isOn: function isOn() {
      return node.data.on || false;
    },
    setOn: function setOn(on) {
      node.setData(__assign(__assign({}, node.data), {
        on: on
      }));
    }
  };
};

var withToggleTo = function withToggleTo(OffComp) {
  return function (OnComp) {
    return mobx_react_lite_1.observer(function (props) {
      var _a = useAccessors(),
          isOn = _a.isOn,
          setOn = _a.setOn;

      var unwrap = function unwrap() {
        return setOn(false);
      };

      var wrap = function wrap() {
        return setOn(true);
      };

      return isOn() ? react_1.default.createElement(OnComp, __assign({}, props, {
        unwrap: unwrap,
        nodeKey: "component"
      })) : react_1.default.createElement(OffComp, __assign({}, props, {
        wrap: wrap,
        nodeKey: "component"
      }));
    });
  };
};

exports.withToggleTo = withToggleTo;
var withToggle = withToggleTo(core_1.withOnlyProps('key', 'children')(react_1.Fragment));
exports.withToggle = withToggle;

var withToggleButton = function withToggleButton(options) {
  var useMenuOptions = function useMenuOptions() {
    var icon = options ? options.icon : false;
    var label = options ? options.label : undefined;

    var _a = useAccessors(),
        setOn = _a.setOn,
        isOn = _a.isOn; // We can return an invariant set of menu options bc state only depends
    // on the mobx data store.


    var menuOptions = react_1.useMemo(function () {
      return [{
        icon: icon || 'toggle_off',
        name: 'Toggle',
        label: label,
        isHidden: function isHidden() {
          return isOn();
        },
        handler: function handler() {
          return setOn(true);
        },
        global: false,
        local: true,
        group: 'toggle-group'
      }, {
        name: 'toggle-group',
        label: label,
        isHidden: function isHidden() {
          return isOn();
        },
        global: false,
        local: true,
        Component: 'group'
      }];
    }, []);
    return menuOptions;
  };

  return core_1.withMenuOptions({
    useMenuOptions: useMenuOptions,
    name: 'toggle'
  });
};

exports.withToggleButton = withToggleButton;

exports.withToggleOnSubmit = function (Component) {
  return function (props) {
    var setOn = useAccessors().setOn;
    return react_1.default.createElement(Component, __assign({
      nodekey: "component",
      onSubmit: function onSubmit() {
        return setOn(true);
      }
    }, props));
  };
};

var withWrapOnSubmit = function withWrapOnSubmit(Component) {
  return function (_a) {
    var wrap = _a.wrap,
        rest = __rest(_a, ["wrap"]);

    return react_1.default.createElement(Component, __assign({}, rest, {
      onSubmit: wrap
    }));
  };
};

exports.withWrapOnSubmit = withWrapOnSubmit;